<div class="header-title"> 
    <div class="flex u-align-items-center u-pa-20">
        <div class="flex flex-align-center">
                <a routerLink="/global-navigation" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button"> 
                    <span class="u-icon icon-chevron-left"></span>
                    <span class="u-button-text">Back</span>
                </a>
            </div>
            <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
                <h1 class="font-semibold u-ma-0 flex header-title--name"> Navigation (Spanish)</h1>
            </div>
    </div>
    <div class="c-header__gradient"></div>
</div>
<maced-global-navigation id="globalNavigationId1" [menuToggleStateLabel]="menuToggleStateLabelSpanish" styleClass="testClass" [menuList]="menuListSpanish" [isOpened]="menuExpandCollapse" [currentRoute]="currentRoute"></maced-global-navigation>